import { GenericObject } from '@dxb-web-ui-framework/common/types';
import { Account } from '../entities';
import { PartyIdentification } from '../../../../../card/src/types';

const topUpAccountStartRequestAdapter = (
  account: Account | null,
  corporate: boolean,
  customerId: string,
  partyIdentification: PartyIdentification | undefined,
): GenericObject => {
  const { accountNumber, beneficiary, availableBalance, currency } = account ?? {};

  return {
    parameters: Object.assign(
      {
        toAccountDetails: {
          accountIdentification: {
            type: 'AccountNumber',
            identifier: {
              value: accountNumber,
              issuingAuthority: 'Profits',
            },
          },
          accountHolderName: beneficiary,
          balances: [
            {
              balance: {
                value: availableBalance,
                currency,
              },
              type: 'Available',
            },
          ],
        },
      },
      corporate && {
        corporate,
        partyIdentifications: [partyIdentification],
        parentPartyIdentifications: [
          {
            type: 'CoreBankingIdentifier',
            identifier: {
              value: customerId,
              issuingAuthority: 'Profits',
            },
          },
        ],
      },
    ),
  };
};

export { topUpAccountStartRequestAdapter };
